import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import "./Availability.css";

const AnimatedContainer = () => {
  const controls = useAnimation(); // Controls for the animation
  const [ref, inView] = useInView({ threshold: 0.1 }); // Detect when in view

  // Trigger animation when the element is in view
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref} // Attach the ref to the container
      initial="hidden" // Initial state
      animate={controls} // Controlled by Framer Motion
      variants={{
        hidden: { opacity: 0, y: 40 }, // Hidden state
        visible: { opacity: 1, y: 0 }, // Visible state
      }}
      transition={{ duration: 1, ease: "easeOut" }} // Animation timing
    >
      <Container>
        <Row>
          <Col xs={12} md={7} xl={7} className="left-col">
            <p>
              {" "}
              I’m currently available for new projects. Feel free to reach out
              and I will get back to you as soon as possible.{" "}
            </p>
          </Col>
          <Col xs={12} md={5} xl={5} className="right-col">
            <CheckCircleFill color="#3AAA72" className="availability-icon" style={{ marginRight: "14px", flexShrink: 0 }} />
            <h2 className="Available" style={{ color: "#3AAA72" }}>Available</h2>
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
};

const Availability = () => {
  return (
    <section className="availability" id="availability">
      <AnimatedContainer />
    </section>
  );
};

export default Availability;
